<template>
  <div>
    <Input search placeholder="角色名称搜索"></Input>
    <div class="personnel-content">
      <template v-if="multiple">
        <Checkbox
          class="staff-item-box"
          v-for="(item, index) in list"
          :label="item.id"
          :key="item.id"
          :value="item.checked"
          @on-change="handleCheck(index)"
        >
          <div class="staff-item-user">
            <div class="staff-item-title">{{ item.name }}</div>
            <div class="staff-item-content u-ellipsis">
              {{ item.roleName }}
            </div>
          </div>
        </Checkbox>
      </template>
      <template v-else>
        <Radio
          class="staff-item-box"
          v-for="(item, index) in list"
          :label="item.id"
          :key="item.id"
          :value="item.checked"
          @on-change="handleSelect(index)"
        >
          <div class="staff-item-user">
            <div class="staff-item-title">{{ item.name }}</div>
            <div class="staff-item-content u-ellipsis">
              {{ item.roleName }}
            </div>
          </div>
        </Radio>
      </template>
    </div>
  </div>
</template>

<script>
import { getRole } from "../../../api/components";
import mixins from "./mixin";
export default {
  name: "role",
  mixins: [mixins],
  props: {
    checkedId: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.getAjaxData();
  },
  data() {
    return {
      list: [], //角色列表
      ajaxData: [], //ajax数据
      id: this.checkedId
    };
  },
  methods: {
    getAjaxData() {
      getRole()
        .then(res => {
          this.ajaxData = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    formatAjaxData(ajaxData) {
      this.list = [];
      ajaxData.forEach(item => {
        this.list.push({
          id: item.id,
          name: item.name,
          checked: this.id.includes(item.id),
          roleName: item.desc
        });
      });
    },
    handleCheck(index) {
      let node = this.list[index];
      this.$set(node, "checked", !node.checked);
    },
    handleSelect(index) {
      let node = this.list[index];
      let currentCheckedIndex = this.list.findIndex(item => {
        return item.checked;
      });
      if (currentCheckedIndex >= 0 && currentCheckedIndex !== index) {
        this.$set(this.list[currentCheckedIndex], "checked", false);
      }
      this.$set(node, "checked", !node.checked);
    },
    getCheckedNodes() {
      return this.list.filter(item => {
        return item.checked;
      });
    },
    // getCheckedNodesId() {
    //   let checkedData = this.getCheckedNodes();
    //   return checkedData.map(item => {
    //     return item.id;
    //   });
    // },
    delChecked(id) {
      //删除已选角色
      let index = this.list.findIndex(item => {
        return item.id === id;
      });
      let node = this.list[index];
      this.$set(node, "checked", false);
    }
  },
  watch: {
    list: {
      handler() {
        let checkedNodes = this.getCheckedNodes();
        // let checkedNodesId = this.getCheckedNodesId();
        this.$emit("on-change", checkedNodes);
      },
      deep: true
    },
    ajaxData: {
      handler(val) {
        this.formatAjaxData(val);
      }
    },
    checkedId(val) {
      this.id = val;
      this.formatAjaxData(this.ajaxData);
    }
  }
};
</script>
